import React, { useState } from 'react'
import { Button, Input, Label } from 'reactstrap'
import { Link } from 'react-router-dom'
import BroadcastModal from '../../components/Common/BroadcastModal'
import { useDispatch } from 'react-redux'
import { showPopup } from '../../store/popup/actions'

function BroadcastPage() {
  const dispatch = useDispatch()
    const [typeList,setTypeList] = useState([{type:'guest_topic',selected:false},{type:'client_topic',selected:false},{type:'vendor_topic',selected:false}])
    const [title,setTitle] = useState('')
    const [description,setDescription] = useState('')
    const [show,setShow] = useState(false)

  return (
    <div className="page-content">
      <BroadcastModal setShow={setShow} show={show} typeList={typeList} setTypeList={setTypeList} title={title} description={description}/>
    <div className="container-fluid">
    <div className="mb-3 col-4">
            <Label>Title</Label>
            <Input
              name="title"
              type="text"
              placeholder="Write something here.."
              onChange={(e)=>setTitle(e.target.value)}
            />
          </div>
          <div className="mb-3 col-4">
            <Label>Description</Label>
            <Input
              name="description"
              type="textarea"
               style={{height:300}}
              placeholder="Write something here.."
              onChange={(e)=>setDescription(e.target.value)}
            />
          </div>
   
                          <Button
                       
                            className="btn btn-primary"
                            onClick={()=>!title || !description ?   dispatch(showPopup({title:'broadcast should contain title and description',warning:true})) : setShow(true)}
                          >
                            Send
                          </Button>
                     
        </div>
        </div>
  )
}

export default BroadcastPage